
            <div
              class="d-flex flex-sm-row flex-md-row flex-lg-row flex-xl-column flex-col flex-grow-1 align-items-center align-items-sm-center px-2 pt-2 text-white justify-content-between h-100"
            >
              <span
                class="d-flex align-items-center pb-sm-3 mb-md-0 me-md-auto text-white text-decoration-none"
              >
                <div class="logo-holder">
                  <a>
                    <img
                      src="assets/img/logo.svg"
                      class="img-fluid logo-image"
                      alt="logo"
                      style="cursor: default"
                    />
                  </a>
                </div>
              </span>
              <div class="app-navigation">
                <ul class="m-0 p-0">
                  <li class="py-2"><a (click)="backToDashboard()"><img *ngIf="!isDashBoard"
                    height="30" width="30"
                    src="assets/img/dashboard-2.svg" alt="dashboard-2"
                     />
                     <img
                     *ngIf="isDashBoard"
                    height="30" width="30"
                    src="assets/dashboard-filled.svg" alt="dashboard-2"
                     />
                    </a></li>
                     <li class="py-2"><a (click)="profileView()"><img *ngIf="!isSettings"
                      height="30" width="30"
                      src="assets/img/settings-2.svg" alt="settings-2"
                       />
                       <img
                       height="30" width="30" *ngIf="isSettings"
                       src="assets/setting-icon.svg" alt="settings-2"
                        /></a></li>
                </ul>
              </div>

              <div
                class="dropdown logout-ico user-fig py-sm-2 py-md-0 py-lg-0 mt-xs-0 mt-sm-0 mt-md-2 mt-lg-2 ms-auto ms-sm-0 mb-lg-4 mb-md-4 mb-xs-0 flex-shrink-1">
                <img
                  src="assets/img/logout-2.svg"
                  (click)="logout()"
                  alt="hugenerd"
                  height="35"
                  width="35"
                  class="rounded-circle logout"
                   />
              </div>
            </div>
          